import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { emptyCart } from "../actions/cartActions";
import { clearOrder } from "../actions/orderActions";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "../components/ExtendedLink";
import TrustBoxReviewCollectorContainer from '../containers/TrustBoxReviewCollectorContainer';
import { resetOpenpayPlan } from "../actions/openpayActions";
import Alert from "../components/Alert";
import { withRouter } from "react-router";

class CheckoutComplete extends Component {
    state = { orderId: 0, hasRefreshed: false };

    componentDidMount() {

        const refreshed = this.props.match.params.status === 'refreshed';
        if (refreshed) {
            this.setState({ hasRefreshed: refreshed });
            this.props.emptyCart();
            this.props.clearOrder();
        }

        if (this.props.order === 0)
            return;
        this.setState({ orderId: this.props.orderResponse.newOrderId });
        this.props.resetOpenpayPlan();

        const { settings, cart, checkoutSale  } = this.props;
        const saleTotal = checkoutSale ? (checkoutSale.totalCustomerPrice + checkoutSale.totalDeliveryFees + checkoutSale.totalPSTTaxValue + checkoutSale.totalHSTGSTTaxValue) : 0;
        if (window.fbq) {
            var fbqContentsList = cart ? cart.lines.map(line => ({ id: line.product.stockItemCode, quantity: line.quantity })) : [];
            window.fbq('track', 'Purchase', { currency: settings.isoCurrencySymbol, value: saleTotal, num_items: cart.lines.length, content_type: 'product', contents: fbqContentsList });
        }

        if (window.vgo) {
            window.vgo('update');
            window.vgo('process');
        }


        if (window.gtag && checkoutSale) {
            window.gtag('event', 'purchase', {
                currency: settings.isoCurrencySymbol,
                items: cart.lines.map(line =>
                ({
                    item_id: line.product.stockItemCode,
                    item_name: line.product.title,
                    item_category: line.product.groupName,
                    price: line.product.specialPrice,
                    currency: settings.isoCurrencySymbol,
                    quantity: line.quantity
                })),
                value: saleTotal,
                transaction_id: this.props.orderResponse.newOrderId,
                shipping: checkoutSale.totalDeliveryFees,
                tax: checkoutSale.totalTaxValue + checkoutSale.totalPSTTaxValue + checkoutSale.totalHSTGSTTaxValue
            });
        }

        this.props.emptyCart();
        this.props.clearOrder();
    }

    render() {
        const { t, settings } = this.props;
        const showTrustPilot = settings.trustPilotBusinessUnitId && settings.customDomain;
      
        const refreshMessage = `${t("You chose to refresh your page while your order is being processed.")}, ${t("You will be receiving an email shortly with confirmation of your order.")}`;
        return (
            <div className="card text-center">
                <div className="card-body padding-top-2x">
                    {this.state.orderId > 0 && (<Fragment>
                        <h3 className="card-title">{t("Thank you for your order!")}</h3>
                    < p className="card-text" > {t("Your order has been placed and will be processed as soon as possible.")}</p>
                        <p className="card-text" > {t("Make sure you make note of your order number, which is")} <span className="text-medium">{this.state.orderId}</span></p>
                        <p className="card-text">
                            {t("You will be receiving an email shortly with confirmation of your order.")}
                            {/* <u>You can now:</u> */}
                        </p>
                    </Fragment>)}
                    {this.state.hasRefreshed && <Alert type="info" title={t("Checkout")} msg={refreshMessage} />}

                    <div className="padding-top-1x padding-bottom-1x d-flex justify-content-center">
                        {showTrustPilot &&  < TrustBoxReviewCollectorContainer />}
                        <ExtendedLink to={settings.baseUrl} className="btn btn-primary">
                            {t("Go Back Shopping")}
                        </ExtendedLink>
                        {/* <a className="btn btn-outline-primary" href="order-tracking.html"><i className="icon-location"></i>&nbsp;Track order</a> */}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ orderResponse, settings, cart, checkoutSale }, ownProps) {
    return { orderResponse, settings, cart, checkoutSale, ...ownProps };
}


export default withTranslation()(withRouter(connect(mapStateToProps, { emptyCart, clearOrder, resetOpenpayPlan })(CheckoutComplete)));